function Loading() {
    return (
        <div className="flex justify-center items-center h-80">
            <span className="block w-20 h-20 animate-spin rounded-full border-[4px] border-t-transparent"></span>
        </div>
    )
}

export default Loading
